import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'

Vue.config.productionTip = false
Vue.prototype.$api = api

// Hydrate auth (read token -> /auth/me) before mounting app
store.dispatch('auth/hydrate').finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
